export default __webpack_public_path__ + "static/media/bundle-highlight.6058554a.png";